import { render } from "./B2bOurStaff.vue?vue&type=template&id=73e24bb0&scoped=true&ts=true"
import script from "./B2bOurStaff.vue?vue&type=script&lang=ts"
export * from "./B2bOurStaff.vue?vue&type=script&lang=ts"

import "./B2bOurStaff.vue?vue&type=style&index=0&id=73e24bb0&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\bd59560cf4570ff\\src\\TicketSolutions.Personalisation.Client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73e24bb0"]])

export default __exports__